import { styled, StyledText } from '@raskrask-dk/rr-components'

export const ServiceTexts = styled('div', {
    display: 'grid',
    gap: 4,
    pb: 54,

    [`& ${StyledText}`]: {
        whiteSpace: 'pre-line',
    },
})

export const StyledGoToServicePicker = styled('div', {
    alignItems: 'center',
    bgc: '$primary600',
    color: '$white',
    display: 'flex',
    gap: '$3',
    m: '-$3 -$3 0',
    p: '$2 $3',

    svg: {
        fontSize: 20,
    },
})

export const ServicePicker = styled('div', {
    alignContent: 'start',
    display: 'grid',
    gap: '$3',
})
